import { UPDATE_TOP_STORES_WIDGET } from "./actionTypes";

const initialState = {
  data : {}
};

const topStoresWidget = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_TOP_STORES_WIDGET:
      state = { ...state, data: action.payload};
      break;
    
    default:
      break;
  }
  return state;
};

export default topStoresWidget;
